import { ChartingSelections } from "components/charting/types";
import { createContext } from "react";

export type SetChartingSelections = (
  updatedSelections: Partial<ChartingSelections> | ((selections: ChartingSelections) => Partial<ChartingSelections>)
) => void;

const SetChartSelectionsContext = createContext<SetChartingSelections | undefined>(undefined);
export default SetChartSelectionsContext;
